module.exports = __webpack_public_path__ + "static/media/smoking.e0b1b911.svg";